import { FC } from 'react';
import { SelfServiceAPI } from 'types';
import { formatMoney } from 'lib/formatters';

const FormattedMoney: FC<SelfServiceAPI.Total> = (money) => <>{formatMoney(money)}</>;

export default FormattedMoney;
